import Title from "components/common/atoms/Title";
import { t } from "../translation/Translation";
import { selectAuth } from "features/auth/AuthSlice";
import { useSelector } from "react-redux";
import { AREA_MANAGER, OFFICE_MANAGER, RECRUITER, ADMIN, SUPER_ADMIN, ACCOUNT_MANAGER} from "Constants";
import ManageRecruiterReports from "./ManageRecruiterReports";
import ManageOmReports from "./ManageOmReports";
import ManageAccountManagerReports from "./ManageAccountManagerReports";
import type { RootState } from "store";
import { clearDestinationPath, setActiveTab } from "features/NavigationSlice";
import { useDispatch } from "react-redux";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";

export const timePeriods = [
  {
    label: "Weekly",
    value: 1
  },
  {
    label: "Monthly",
    value: 2
  }
]

const ManageReports: React.FC = () => {
  const dispatch = useDispatch();
  const authUser = useSelector(selectAuth);
  const getInitialType = () => {
    let type = "";
    if (authUser.role === RECRUITER) {
      type = "recruiter";
    } else if (authUser.role === ACCOUNT_MANAGER) {
      type = "am";
    } else if (authUser.role === OFFICE_MANAGER || authUser.role === AREA_MANAGER || authUser.role === ADMIN || authUser.role === SUPER_ADMIN) {
      type = "om";
    }
    // else if (authUser.role === ADMIN) {
    //   type = "teamLead"
    // }
    return type;
  }

  const defaultTabData = {
    tabFieldName: "",
    tabFieldValue: getInitialType(),
  };

  const activeTab = useSelector((state: RootState) => state.navigation.activeTab) ?? defaultTabData;

  const handleNavItemClick = (tabFieldName: string, tabFieldValue: any) => {
    dispatch(clearDestinationPath());
    dispatch(setActiveTab({ tabFieldName, tabFieldValue }));
  };

  return (
    <AccessControl
      requiredPermissions={[
        {
          permission: "Reports",
          read: true,
        },
      ]}
      renderNoAccess={true}
    >
      <Title
        title={t("Manage reports")}
      />
      <div className="form-height-config-settings mt-2">
        <div className="row pb-3">
          <div className="col-md-12 vacancy-tabs">
            {(authUser.role === SUPER_ADMIN || authUser.role === ADMIN || authUser.role === AREA_MANAGER || authUser.role === OFFICE_MANAGER) &&
              <button
                className={`link ${activeTab.tabFieldValue === "om" ? "active" : ""
                  } text-decoration-none me-3 border-0 bg-transparent ps-0`}
                onClick={(e) => handleNavItemClick("Office manager", "om")}
              >
                {t("Office manager")}
              </button>
            }
            {/* The office manager gives feedback on the account manager's monthly report, so they
                get the tab too, as they already do for the recruiter reports. */}
            {(authUser.role === SUPER_ADMIN || authUser.role === ADMIN || authUser.role === AREA_MANAGER || authUser.role === ACCOUNT_MANAGER || authUser.role === OFFICE_MANAGER) &&
              <button
                className={`link ${activeTab.tabFieldValue === "am" ? "active" : ""
                  } text-decoration-none me-3 border-0 bg-transparent ps-0`}
                onClick={(e) => handleNavItemClick("Account manager", "am")}
              >
                {t("Account manager")}
              </button>
            }
            {(authUser.role === SUPER_ADMIN || authUser.role === ADMIN || authUser.role === AREA_MANAGER || authUser.role === OFFICE_MANAGER || authUser.role === RECRUITER) &&
              <button
                className={`link ${activeTab.tabFieldValue === "recruiter" ? "active" : ""
                  } text-decoration-none me-3 border-0 bg-transparent ps-0`}
                onClick={(e) => handleNavItemClick("Recruiter", "recruiter")}
              >
                {t("Recruiter")}
              </button>
            }
            {/* <button
              className={`link cursor-pointer ${activeTab.tabFieldValue === "teamLead" ? "active nav-subtab" : "nav-subtab"
                } text-decoration-none me-3 border-0 bg-transparent ps-0`}
              onClick={(e) => handleNavItemClick("teamLead")}
            >
              {t("Team lead")}
            </button> */}
          </div>
        </div>
        {activeTab.tabFieldValue === "om" && <ManageOmReports />}
        {activeTab.tabFieldValue === "am" && <ManageAccountManagerReports />}
        {activeTab.tabFieldValue === "recruiter" && <ManageRecruiterReports />}
        {/* {activeTab.tabFieldValue === "teamLead" && <ManageTeamLeadReports />} */}
      </div>
    </AccessControl>
  );
}

export default ManageReports;